export default function convertToKebabCase(camelCasedText: string): string {
  return camelCasedText.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
}
